
import Geoserver from '../../helpers/geoserver'; 

  export class Legendgraphics{
    constructor(layer, style,  component){
        this.component = component;
        this.layer = layer;
        this.markup =  `
            <div class="mt-3 bg-white"><div class="text-black font-bold">${this.component}</div><img
                max-height="150"
                max-width="250"
                src= "${Geoserver.LegendGraphic(layer, style, component).url}"
            ></img></div>
            `
    }
    onAdd(map){
      this.map = map;
      this.container = document.createElement('div');
      this.container.innerHTML = this.markup.trim();
      this.container.className = 'my-custom-control';
      return this.container;
    }
    onRemove(){
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    }
  }

